import {
	SET_GROWTHBOOK_CALLBACK,
	SET_GROWTHBOOK_FEATURE_ENABLED,
	SET_GROWTHBOOK_FEATURE_VARIANT,
} from '../actions/growthbookActions';

const initialState = {
	growthbookCallback: null,
	features: {},
};

const actionMap = {
	[SET_GROWTHBOOK_CALLBACK]: (state, action) => {
		return {
			...state,
			growthbookCallback: action.payload,
		};
	},
	[SET_GROWTHBOOK_FEATURE_ENABLED]: (state, action) => {
		return {
			...state,
			features: {
				...state.features,
				[action.payload.featureId]: {
					...state.features[action.payload.featureId],
					isEnabled: action.payload.isEnabled,
				},
			},
		};
	},
	[SET_GROWTHBOOK_FEATURE_VARIANT]: (state, action) => {
		return {
			...state,
			features: {
				...state.features,
				[action.payload.featureId]: {
					...state.features[action.payload.featureId],
					variant: action.payload.variant,
				},
			},
		};
	},
};

const reducer = (state = initialState, action) => {
	const reducer = actionMap[action.type];
	return reducer ? reducer(state, action) : state;
};

export default reducer;
